/*
 * Google reCAPTCHA v3 helper.
 *
 * The script is loaded from www.recaptcha.net (see public/index.html), NOT
 * www.google.com, because many ad blockers and privacy extensions block
 * requests to www.google.com/recaptcha. When that happens `window.grecaptcha`
 * is never defined and every form that needs a token silently breaks.
 * https://developers.google.com/recaptcha/docs/faq
 */

/**
 * Runs reCAPTCHA v3 and resolves with a fresh token.
 *
 * Rejects with an Error('RECAPTCHA_UNAVAILABLE') when the reCAPTCHA script
 * failed to load (e.g. blocked by an ad blocker / privacy extension) so callers
 * can surface a clear message instead of throwing on `window.grecaptcha` being
 * undefined.
 *
 * @returns {Promise<string>} the captcha token to send in the `Captcha` header
 */
export default function executeRecaptcha() {
  return new Promise((resolve, reject) => {
    const { grecaptcha } = window;

    if (!grecaptcha || typeof grecaptcha.ready !== 'function') {
      reject(new Error('RECAPTCHA_UNAVAILABLE'));
      return;
    }

    grecaptcha.ready(() => {
      grecaptcha
        .execute(process.env.REACT_APP_CAPTCHA, { action: 'submit' })
        .then(resolve)
        .catch(() => reject(new Error('RECAPTCHA_UNAVAILABLE')));
    });
  });
}
